import { Component, OnInit, EventEmitter, Output, HostListener, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MKSService } from './admin-mks.service';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, delay } from 'rxjs/operators';
import { UserGroupService } from 'src/app/core/services/user-group/user-group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-admin-mks',
    templateUrl: './admin-mks.component.html',
    styleUrls: ['./admin-mks.component.scss'],
})
export class MKSComponent {
    isAllChecked: boolean = false;
    isAllCheckedUsergroup: boolean = false;
    users: any;
    search: string = ''; // Search query
    site_role: string = '';
    searchText = '';
    sitenameText = '';
    descriptionText = '';
    siteID = '';
    siteName = '';
    siteVisibility: any;
    showDropdown = false;
    highlighted: string = '';
    faEllipsisV = faEllipsisV;
    currentPage: number = 1; // Current page
    itemsPerPage = 10; // Items per page
    totalItems: any; // Total items
    totalPages: any; // Total pages
    clients: any;
    pageNumber = {
        page: 1,
    };
    disableForm = true;
    filteredClients = []; // Clients filtered based on search

    filteredClientsForm = [];
    searchTerm: string = ''; // For two-way binding with search bar

    isDropdownOpen: boolean = false; // Controls dropdown visibility
    searchIdsForUserGroupData: any;
    // selectedClient: string | null = null; // Selected clientselectedClients: string[] = []; // List of selected clients
    // selectedClient: string = ''; // Selected client
    selectedClient: string | null = null; // Stores the selected client
    clientsList = [];
    UsersList: Array<any> = [];

    // showDropdown: boolean = false; // Dropdown visibility
    showcreateandEditForm = false;
    clientList: any = [];
    userGroups: any;
    siteUserGroupsList: any;
    isOpenUserGroupModal: boolean = false;
    selectedClientIds: Array<any> = [];
    searchUserGroupName: string = '';

    roles: any;
    // accessOptions = ['Access1', 'Access2', 'Access3', 'Access4'];
    pageSize = 5;
    searchListArray: any;
    userGroupForm: any;
    options: any;
    // options = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
    selectedOptions: any;

    multifilteredClients: any;
    multiclients: any;
    multisearchTerm: string = '';
    multiisDropdownOpen: boolean = false;
    multiselectedClient: string = '';
    // multiselectedClients :any[] = [];
    // multiselectedClients :any; // Properly typed and initialized
    multiselectedClients: any = []; // Properly typed and initialized
    keepDropdownOpen: boolean = false; // Prevent dropdown from closing on interaction
    selectedVisibility = '';
    selectedIds: any;
    disableSubmit = false;
    usergroupId: any;
    isMobile = false;
    mksList: any;
    selectedClientCountText = '#count# Client(s) Selected';
    selectedAccessCountText = '#count# Access(s) Selected';
    selectedAccessBlankText = 'Select';
    selectedClientBlankText = 'No Client Name Selected';
    selectedClientClear: boolean = false;
    activeAccessList: number | null = null;
    private createUserGroupForClient: Subscription;
    isLoadingData = true;
    isLoadingDataUserGroup = false;
    errors: { [key: string]: string } = {};
    siteRole: any;
    modalheader: any;
    mksid: string = '';
    emailId: any = '';
    toastrService: any;
    currentLimit: number = 0;
    currentOffset: number = 0;
    sitename: any;
    isLoading: boolean = true;
    isSaveUserGroup: boolean = false;
    StatusCode: number = 0;
    @ViewChild('wrapper') wrapper!: ElementRef;
    @ViewChild('rows') rows!: ElementRef;
    @ViewChild('tableHeader') tableHeader!: ElementRef;
    @ViewChild('tableWrapper') tableWrapper!: ElementRef;
    Loading: boolean = false;

    detectRowsWithIssues(index: number): void {
        let wrapperHeight = this.wrapper.nativeElement.offsetHeight;
        const rowElements = this.rows.nativeElement.children;
        let totalRowHeight = 0;
        const currentScrollTop = this.wrapper.nativeElement.scrollTop;
        for (let i = 0; i <= index; i++) {
            const rowHeight = rowElements[i].offsetHeight;

            totalRowHeight += rowHeight;
        }
        if (wrapperHeight >= 290) wrapperHeight = 290;
        const rowTop = rowElements[index].offsetTop;
        const rowBottom = rowTop + rowElements[index].offsetHeight;

        if (rowBottom > currentScrollTop + wrapperHeight || rowTop < currentScrollTop) {
            const newScrollTop = rowTop - wrapperHeight + 20;
            this.wrapper.nativeElement.scrollTo({ top: newScrollTop, behavior: 'smooth' });
        }
    }

    //   ngAfterViewInit(): void {
    //     this.detectRowsWithIssues();
    //   }

    onToggle(option: any, value: any) {
        const index = this.selectedOptions.indexOf(option);
        if (value.target.checked) {
            option.isSelected = true;
        } else {
            option.isSelected = false;
        }
        console.log('option 1 2 3 4', option, value);
        if (index > -1) {
            // If the option is already selected, remove it
            this.selectedOptions.splice(index, 1);
        } else {
            // Otherwise, add it
            this.selectedOptions.push(option);
        }

        this.selectedIds = this.selectedOptions.map((option: { id: any }) => option.id);
        console.log('this.selectedOptions are', option, JSON.stringify(this.selectedOptions), this.selectedIds);
    }

    getSelectedOptions() {
        console.log('selectedOptions are selectedOptions', this.selectedOptions);
        if (this.selectedOptions?.length > 0) {
            // Join the selected options with a comma separator
            return this.selectedOptions.map((option: { name: any }) => option.name);
        } else {
            return 'Select';
        }
    }

    clearSearch() {
        this.siteNameFilter = ''; // Clear the search input
        this.loadMKSlist();
    }

    clearUserGroupsSearch() {
        this.searchText = '';
    }

    clearSearchClient() {
        this.searchClientName = ''; // Clear the search input
        if (this.isAllChecked) {
            this.isAllChecked = false;
        }
        this.loadUsers();
    }

    clearSearchUserGroup() {
        this.searchUserGroupName = ''; // Clear the search input
        if (this.isAllCheckedUsergroup) {
            this.isAllCheckedUsergroup = false;
        }
        this.getUserGroupsBySite();
    }

    clearSelection(): void {
        this.selectedClient = null;
        this.searchTerm = ''; // Reset the input value
        this.filteredClients = []; // Clear filtered clients
        this.clientSearchList();
    }

    activePopupIndex: number | null = null;
    toggleList(index: number, event: Event) {
        event.stopPropagation();
        if (this.activeAccessList === index) {
            // Close the "Access" popup
            this.activeAccessList = null;
        } else {
            // Open the "Access" popup and close the "Actions" popup
            this.activeAccessList = index;
            this.activePopupIndex = null;
        }
    }

    // Toggles the "Actions" popup
    togglePopup(index: number, event: Event): void {
        this.detectRowsWithIssues(index);
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
        }
    }

    // Close all popups when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.activePopupIndex = null;
        this.activeAccessList = null;
    }

    restrictInputForID(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9\-]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    editSite(site: any, modal: TemplateRef<any>) {
        //this.modalService.open(modal, { backdrop: 'static', keyboard: false });
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.disableForm = true;
        console.log('Edited item is', site);
        this.getSiteVisibility();
        this.siteID = site.id;
        this.validateField('siteID');
        this.selectedVisibility = site.visibility.toLowerCase().replace(/^\w/, (c: any) => c.toUpperCase());
        console.log(this.selectedVisibility);
        //this.showcreateandEditForm = true;
        this.sitenameText = site.name;
        this.descriptionText = site.description;
    }

    isMKSLoadingData = false;
    editGroup(mks: any, modal: TemplateRef<any>) {
        this.isMKSLoadingData = true;
        this.isAllChecked = false;
        this.modalService.open(modal, { size: 'lg', backdrop: 'static', windowClass: 'custom-modal-userGroupmks', keyboard: false });
        this.pageNumber = {
            page: 1,
        };
        this.currentPage = 1;
        this.disableForm = true;
        console.log('Edited item is', mks);
        this.mksid = mks.id;
        this.sitename = mks.name;
        this.searchClientName = '';
        this.selectedUserGroupItems = []; // Preselected item(s)
        this.selectedClientItems = [];
        this.loadUsers();
        // this.isAllChecked = false;
        const userGroupAry: any = this.selectedUserGroupItems.map((item: any) => item.name);
        const clientAry: any = this.selectedClientItems.map((item: any) => item.name);
        const userupdateData = {
            siteId: this.mksid,
            filter: {
                search: this.searchClientName,
                limit: 10,
                offset: 0,
                userGroupName: clientAry,
                clientName: userGroupAry,
            },
        };
        this.myknowledgestore.getUserupdate(userupdateData).subscribe({
            next: (response) => {
                this.UsersList = response.users.map((user: any) => ({
                    ...user,
                    isModified: false, // Initialize change-tracking property
                }));
                this.totalItems = response.totalCount;
                this.isMKSLoadingData = false;
                this.UsersList.forEach((user: any) => {
                    user.isChecked = user.siteRole !== null && user.siteRole !== undefined;
                    user.isRoleFromAPI = user.siteRole !== null && user.siteRole !== undefined;
                });
            },
            error: (err) => {
                console.error('Error loading users:', err);
            },
        });
        this.loadDropdownData();
        this.LoadSiteRole();
        this.clientSearchList();
    }

    deleteGroup(group: any) {
        console.log('Delete:', group);
        // Add your delete logic here
    }

    constructor(
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private usergroup: UserGroupService,
        private myknowledgestore: MKSService,
        private toast: ToastrService,
        private eRef: ElementRef,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private router: Router,
        private commonservice: CommonServiceService,
    ) {
        this.createUserGroupForClient = this.commonservice.createUserGroupForClient$.subscribe((data) => {
            if (data?.createnew) {
                console.log('the value for createUserGroupForClient is', data.data.name);
                setTimeout(() => {
                    this.createButton?.nativeElement?.click();
                    this.selectedClient = data.data.name;
                    this.searchTerm = data.data.name; // Show the selected value in the input
                }, 0); //
            }
        });
    }

    @ViewChild('createButton', { static: true }) createButton!: ElementRef<HTMLButtonElement>;
    createnew: boolean | null = null;
    ngOnInit() {
        // this.LoadSiteRole();
        //  this.loadUsers();
        this.checkWidth();
        // this.getSiteVisibility();
        this.loadMKSlist();

        //add a condition for routing through client component

        // this.usergroup.usergroupType().subscribe((data) => {
        //     this.roles = data;
        //     console.log('the result of usergroupType are', data);
        // });
    }

    getSiteVisibility() {
        this.myknowledgestore.getSiteVisibility().subscribe((data) => {
            console.log('site visibility data', data);
            this.siteVisibility = data;
        });
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    clientSearchList() {
        const req = {
            query: '',
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };
        const term = '';
        this.usergroup.getClientList(req).subscribe((data) => {
            this.clientsList = data.clients || [];
            this.filteredClients = data.clients.map((client: { name: any }) => client.name).filter((client: string) => client.toLowerCase().includes(term));
        });
    }

    // clientListUsergroups() {
    //     const req = {
    //         query: '',
    //         limit: null,
    //         offset: 0,
    //         order: 'ASC',
    //         sortBy: 'ClientName',
    //     };
    //     this.usergroup.getClientList(req).subscribe((data) => {
    //         this.clientsList = [];
    //         this.clientsList = data.clients;
    //         console.log('client for usergroup', this.clientsList);
    //     });
    // }

    onChangeUserGroup(selectedValue: string) {
        const reqBody = {
            userGroupId: null,
            query: null,
            userGroupType: selectedValue,
            limit: null,
            offset: 0,
        };
        this.usergroup.getAccessList(reqBody).subscribe((data) => {
            console.log('the response of usergroup access is', JSON.stringify(data.accessList));
            this.options = data.accessList;
            this.selectedAccessItems = this.options.filter((item: { isSelected: any }) => item.isSelected);
            this.selectedOptions = this.options.filter((option: { isSelected: any }) => option.isSelected);
            this.selectedIds = this.selectedAccessItems.map((option: { id: any }) => option.id);
            this.validateField('selectedAccessItems');
        });
        console.log('this.userGroupForm.value', this.sitenameText, this.descriptionText, this.selectedClient, selectedValue);
    }

    blurDropdown(event: FocusEvent): void {
        setTimeout(() => {
            if (!(event.relatedTarget as HTMLElement)?.classList.contains('dropdown-item')) {
                this.showDropdown = false;
            }
        }, 150); // Allow dropdown interaction
    }

    get paginatedGroups() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.UsersList.slice(start, end);
    }

    onAction(group: any) {
        console.log('Action clicked for:', group);
    }

    // Handle dropdown change event
    onClientChange(event: Event): void {
        const selectedValue: string = (event.target as HTMLSelectElement).value;
        console.log('Selected Client:', selectedValue);
    }

    onSelect(searchStr: string) {
        console.log('the selected string is', searchStr);
    }
    onFocus() {
        this.showDropdown = true;
    }

    // Get start and end item indices for the current page
    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    // Navigate to the previous page
    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }

    // Navigate to the next page
    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    }

    checkvalidation() {}

    openSiteCreationForm(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-userGroup', backdrop: 'static', keyboard: false });
        this.errors = {};
        this.siteID = '';
        this.sitenameText = '';
        this.descriptionText = '';
        this.selectedVisibility = '';
        this.disableForm = false;
        this.getSiteVisibility();
    }

    closeCreateandEditForm() {
        this.showcreateandEditForm = false;
        this.modalService.dismissAll();
    }
    closeUpdateUser() {
        this.modalService.dismissAll();
    }

    closeUserGroupModal() {
        this.isOpenUserGroupModal = false;
        this.selectedClientItems = [];
        this.modalService.dismissAll();
    }

    // Filter the clients based on user input
    filterClients(): void {
        console.log('this.searchTerm is', this.searchTerm);
        const term = this.searchTerm.toLowerCase();
        const req = {
            query: term,
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };
        this.usergroup.getClientList(req).subscribe((data) => {
            this.clients = data.clients;
            console.log('the response of usergroup clientlist is', data);
            this.filteredClients = this.clients.map((client: { name: any }) => client.name).filter((client: string) => client.toLowerCase().includes(term));
        });

        console.log('filteredClients are', this.filteredClients);
    }

    // Open the dropdown when input is focused
    toggleDropdown(open: boolean): void {
        this.isDropdownOpen = open;
    }

    // Hide dropdown on blur after a delay to allow mousedown events
    hideDropdown(): void {
        setTimeout(() => {
            this.isDropdownOpen = false;
        }, 200);
    }

    // Select a client and update the search term
    selectClient(client: string): void {
        this.selectedClient = client;
        this.searchTerm = client; // Show the selected value in the input
        this.isDropdownOpen = false; // Close the dropdown
        console.log('Selected Client:', client);
    }

    multiselectClient(client: any): void {
        this.multiselectedClients = client;
        this.multisearchTerm = client; // Show the selected value in the input
        this.multiisDropdownOpen = false; // Close the dropdown
        console.log('Selected Client:', client);
    }

    multihideDropdown(): void {
        setTimeout(() => {
            this.multiisDropdownOpen = false;
        }, 200);
    }

    handleBlur() {
        setTimeout(() => {
            if (!this.keepDropdownOpen) {
                this.multiisDropdownOpen = false;
            }
            this.keepDropdownOpen = false;
        }, 200); // Delay to allow checkbox click to register
    }

    createSite() {
        console.log(' this.usergroupId ', this.usergroupId);
        const request = {
            id: this.siteID,
            name: this.sitenameText.trim(),
            description: this.descriptionText.trim(),
            visibility: this.disableForm ? this.selectedVisibility.toLocaleUpperCase() : this.selectedVisibility,
            isForUpdate: this.disableForm ? true : false,
        };

        // this.selectedClient = this.searchTerm;
        // this.usergroup.createandupdate(request).subscribe((data)=> {
        console.log('the response of usergroup create and update is', request);
        // })
        if (this.siteID !== '' && this.sitenameText !== '' && this.selectedVisibility != '') {
            // Set Loading flag to true before starting the API request
            this.Loading = true;
            this.myknowledgestore
                .createandupdateSite(request)
                .pipe(
                    catchError((error) => {
                        if ([409, 500].includes(error.status)) {
                            // Handle 500 and 409 error specifically
                            console.error('Server error occurred:', error.error.message);
                            this.toast.warning(error.error.message);
                        } else {
                            // Handle other errors
                            console.error('An error occurred:', error);
                        }
                        // Return an empty observable so the app doesn't break
                        return of(null);
                    }),
                )
                .subscribe((data: any) => {
                    // Always set Loading flag to false when response is received
                    this.Loading = false;
                    if (data) {
                        console.log('create site success', data);
                        // API response is successful, handle the data
                        this.toast.success(data.message);
                        //this.showcreateandEditForm = false;
                        this.modalService.dismissAll();
                        this.searchText = '';
                        // this.searchIdsForUserGroupData = [];
                        // this.selectedUserGroupItems = [];
                        //this.selectedClientItems = [];
                        this.loadMKSlist();
                    }
                });
        } else {
            // If validation fails, stop loading
            this.Loading = false;
        }
    }

    OpenupdateUserGroups(site: any, modal: TemplateRef<any>) {
        this.isOpenUserGroupModal = true;
        this.searchUserGroupName = '';
        this.selectedClientItems = [];
        this.selectedClientIds = [];
        this.siteID = site.id;
        this.siteName = site.name;
        this.isAllCheckedUsergroup = false;
        this.modalService.open(modal, { size: 'lg', backdrop: 'static', windowClass: 'custom-modal-userGroupmks', keyboard: false });
        this.isLoadingDataUserGroup = true;
        this.getUserGroupsBySite();
        // this.loadDropdownData();
        this.loadClient();
        this.LoadSiteRole();
        // this.clientSearchList();
        //this.clientListUsergroups();
    }
    getUserGroupsBySite() {
        this.currentPage = 1;
        const req = {
            userGroupFilter: {
                clientIds: this.selectedClientIds.length > 0 ? this.selectedClientIds : [],
                query: this.searchUserGroupName,
                limit: 10,
                offset: 0,
                sortBy: 'UserGroupName',
                order: 'DESC',
            },
            siteId: this.siteID,
        };
        this.myknowledgestore.getUserGroupsBySiteId(req).subscribe((data: any) => {
            this.isLoadingDataUserGroup = false;
            console.log('user groups by site ID', data);
            this.totalItems = data.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.siteUserGroupsList = data.userGroups;
            this.siteUserGroupsList.forEach((userGroup: any) => {
                userGroup.savedSiteRole = userGroup.siteRole;
                userGroup.isChecked = userGroup.siteRole !== null && userGroup.siteRole !== undefined;
                userGroup.siteRoleExist = userGroup.siteRole !== null && userGroup.siteRole !== undefined;
            });
            console.log('siteUserGroupsList', this.siteUserGroupsList);
        });
    }

    callandRefreshusergroup() {
        console.log('this is called first - 2');
        // this.pageNumber = {
        //     page: 1,
        // };
        this.currentPage = 1;
        // const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        // const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        console.log('called here');
        const reqBody = {
            clientIds: this.searchIdsForUserGroupData,
            query: this.searchText,
            limit: 10,
            offset: 0,
            order: 'DESC',
            sortBy: 'UserGroupId',
        };
        this.usergroup.displayUsergroupList(reqBody).subscribe((data) => {
            console.log('called here API');
            this.totalItems = data.totalCount;
            this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
            this.userGroups = data.userGroups;
            this.userGroups.forEach((group: { accessNames: any; accessList: any }) => {
                if (group.accessList.length > 0) group.accessNames = group.accessList.map((access: { label: any }) => access.label).join(', ');
                else group.accessNames = 'No access found';
                group.accessList = group.accessList;
            });
        });
    }

    userGroupList: Array<any> = [];

    loadDropdownData(): void {
        this.loadClient();
        this.loadUsergroup();
        this.loadAllUsergroup();
        // this.loadAllUserRole();
    }

    loadUsergroup(): void {
        const clientIdArys: any = this.selectedClientItems.map((item: any) => item.id);
        const usergroupData = { query: '', limit: 0, offset: 0, clientIds: clientIdArys };
        this.myknowledgestore.getUsergroup(usergroupData).subscribe({
            next: (data) => {
                this.userGroupList = data.userGroups || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }

    loadClient(): void {
        const clientParam = { query: '', limit: 0, offset: 0, order: 'ASC', sortBy: 'ClientName' };
        this.myknowledgestore.getClientName(clientParam).subscribe({
            next: (data) => {
                this.clientList = data.clients || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }

    selectedClientItems: Array<any> = [];

    onSelectionClientChange(selected: Array<any>) {
        if (this.isOpenUserGroupModal) {
            this.selectedClientItems = [];
            this.selectedClientItems = selected;
            console.log('selectedClientItems', this.selectedClientItems);
            this.selectedClientIds = this.selectedClientItems.map((item) => item.id);
            console.log('clientIDs', this.selectedClientIds);
            this.getUserGroupsBySite();
        } else {
            this.selectedClientItems = selected;
            this.search = this.searchClientName;
            console.log('Selected items:', selected);
            this.limit = 10; // Items per page
            this.offset = 0;
            // this.users = [];
            this.loadUsergroup();
            this.loadUsers();
        }
    }

    onSelectionUserGroupChange(selected: Array<any>) {
        this.selectedUserGroupItems = selected;
        this.limit = 10; // Items per page
        this.offset = 0;
        this.search = this.searchClientName;
        //    this.users = [];
        console.log('Selected items:', selected);
        this.loadUsers();
    }

    selectedAccessItems: any;

    multitoggleDropdown(open: boolean): void {
        this.multiisDropdownOpen = open;
    }

    multifilterClients(): void {
        const term = this.multisearchTerm.toLowerCase();
        const req = {
            query: term,
            limit: null,
            offset: 0,
            order: 'ASC',
            sortBy: 'ClientName',
        };

        this.usergroup.getClientList(req).subscribe((data) => {
            this.multiclients = data.clients; // Assuming data.clients is { id, name }[]
            this.multifilteredClients = this.multiclients.filter((client: { name: string }) => client.name.toLowerCase().includes(term));
        });
    }

    isSelected(client: { id: number; name: string }): boolean {
        return this.multiselectedClients.some((selectedClient: { id: number }) => selectedClient.id === client.id);
    }

    updateSearchTerm(): void {
        // Display only names in the input
        this.multisearchTerm = this.multiselectedClients.map((client: { name: any }) => client.name).join(', ');
    }

    onBlur(event: FocusEvent): void {
        const relatedTarget = event.relatedTarget as HTMLElement;
        if (!relatedTarget || !relatedTarget.closest('ul')) {
            this.multiisDropdownOpen = false;
        }
    }

    clearFilteredClients() {
        this.multiselectedClients = []; // Clear the selected clients
        this.multisearchTerm = ''; // Clear the search term in the input box
        this.multifilteredClients = []; // Clear the filtered clients list if required
        this.multiisDropdownOpen = false; // Close the dropdown (optional)
        this.searchIdsForUserGroupData = [];
        //this.SearchList();
        //call API and load all the data
        this.clientSearchList();
    }

    userGroupSearchTermSearch() {
        //if (this.searchText != '') this.SearchList();
    }

    isFormValid() {
        const sitenamePattern = /[a-zA-Z0-9]/;
        return this.siteID?.trim() && this.sitenameText?.trim() && sitenamePattern.test(this.sitenameText) && this.selectedVisibility?.trim();
    }

    validateField(field: string) {
        switch (field) {
            case 'sitenameText':
                this.errors[field] = this.sitenameText.trim() === '' ? 'Site Name is required' : '';
                break;
            case 'siteID':
                this.errors[field] = this.siteID.trim() === '' ? 'Site ID is required' : '';
                break;
            case 'descriptionText':
                this.errors[field] = this.descriptionText.trim() === '' ? 'Description is required' : '';
                break;
            case 'selectedVisibility':
                this.errors[field] = this.selectedVisibility === '' ? 'Visibility is required' : '';
                break;
        }
    }

    limit: number = 100; // Items per page
    offset: number = 0; // Offset (for pagination)

    limitUG: number = 10; // Items per page
    offsetUG: number = 0; // Offset (for pagination)

    selectedUserGroupCountText = '#count# User Group(s) Selected';
    selectedUserGroupBlankText = 'No User Group Selected';
    selectedUserGroupItems: any = []; // Preselected item(s)

    visibleMksList: Array<any> = [];
    filteredMksList: Array<any> = [];
    siteNameFilter: string = '';

    loadMKSlist(): void {
        this.isLoadingData = true;
        this.myknowledgestore.getMKSList().subscribe({
            next: (response) => {
                this.isLoadingData = false;

                this.mksList = response.sites || [];
                console.log('mkslist', this.mksList);

                this.mksList = this.mksList.map((site: { visibility: any; name: any; guid: any; description: any; id: any; isForUpdate: undefined }) => ({
                    visibility: site.visibility || '', // Default to 'PRIVATE' if null
                    name: site.name || '', // Default to 'Unnamed' if null
                    guid: site.guid || '', // Default to empty string if null
                    description: site.description || '', // Default if null
                    id: site.id || '', // Default to empty string if null
                    isForUpdate: site.isForUpdate !== undefined ? site.isForUpdate : false, // Default to false if null/undefined
                }));

                // Apply the filtered and visible lists
                this.filteredMksList = this.mksList;
                this.visibleMksList = this.mksList.map((mks: any) => ({
                    ...mks,
                }));

                this.isLoadingData = false;
            },
            error: (err) => {
                this.isLoadingData = false;
                this.toast.error(err?.error?.message); // Show error toast
            },
        });
    }

    LoadSiteRole() {
        this.myknowledgestore.getSiteRole().subscribe({
            next: (data) => {
                this.siteRole = data;
                // Check if siteRole is not null and set isChecked to true
                this.isChecked = this.siteRole !== null;
            },
        });
    }

    applyFilter(): void {
        this.filteredMksList = this.mksList.filter((mksList: any) => mksList.name.toLowerCase().startsWith(this.siteNameFilter.toLowerCase()));
        this.currentPage = 0;
        this.visibleMksList = this.filteredMksList;
    }

    onScroll(event: any): void {
        alert('alert');
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
            this.tableHeader.nativeElement.style.transform = `translateY(${event.target.scrollTop}px)`;
        }
    }

    // Common logic to check and load MKS list
    loadMKSIfNeeded() {
        if (this.siteNameFilter === '') {
            this.loadMKSlist();
        }
    }

    onSearchTextChanged() {
        this.loadMKSIfNeeded();
    }

    onClearLoad() {
        this.loadMKSIfNeeded();
    }

    // onSearchTextChanged() {
    //     if (this.siteNameFilter == '') {
    //         this.loadMKSlist();
    //     }
    // }
    // onClearLoad() {
    //     if (this.siteNameFilter == '') {
    //         this.loadMKSlist();
    //     }
    // }

    onSearchTextChange() {
        if (this.searchClientName == '') {
            this.loadUsers();
        }
    }
    onSearchTextChangeUserGroup() {
        if (this.searchUserGroupName == '') {
            this.getUserGroupsBySite();
        }
    }

    loadUsers(): void {
        this.isMKSLoadingData = true;
        const userGroupAry: any = this.selectedUserGroupItems.map((item: any) => item.name);
        const clientAry: any = this.selectedClientItems.map((item: any) => item.name);

        const userupdateData = {
            siteId: this.mksid,
            filter: {
                search: this.searchClientName,
                limit: 10,
                offset: 0,
                userGroupName: userGroupAry,
                clientName: clientAry,
            },
        };

        this.myknowledgestore.getUserupdate(userupdateData).subscribe({
            next: (response) => {
                this.isMKSLoadingData = false;
                this.UsersList = response.users || [];
                this.totalItems = response.totalCount || 0;

                // if (Array.isArray(this.UsersList)) {
                //     this.UsersList.forEach((user: any) => {
                //         user.isChecked = user.siteRole !== null && user.siteRole !== undefined;
                //         user.isRoleFromAPI = user.siteRole !== null && user.siteRole !== undefined;
                //     });
                // } else {
                //     console.error('Users list is not an array:', this.UsersList);
                // }

                this.totalItems = response.totalCount;
                this.isMKSLoadingData = false;
                this.UsersList.forEach((user: any) => {
                    user.isChecked = user.siteRole !== null && user.siteRole !== undefined;
                    user.isRoleFromAPI = user.siteRole !== null && user.siteRole !== undefined;
                });
            },
            error: (err) => {
                console.error('Error loading users:', err);

                this.UsersList = [];
            },
        });
        //this.isLoadingData = false;
    }

    onPageChanged(event: any) {
        this.isLoadingData = true;
        console.log('this is called first - 1');

        this.pageNumber = event;
        this.isAllChecked = false;
        this.isAllCheckedUsergroup = false;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        const userGroupAry: any = this.selectedUserGroupItems.map((item: any) => item.name);
        const clientAry: any = this.selectedClientItems.map((item: any) => item.name);
        const userupdateData = {
            siteId: this.mksid,
            filter: {
                search: this.searchClientName,
                limit: limit,
                offset: offset,
                userGroupName: userGroupAry,
                clientName: clientAry,
            },
        };
        this.myknowledgestore.getUserupdate(userupdateData).subscribe((response) => {
            this.isLoadingData = false;
            this.UsersList = response.users;
            // this.UsersList.forEach((user: any) => {
            //     if (user.siteRole === null || user.siteRole === undefined) {
            //         user.isChecked = false;
            //     } else {
            //         user.isChecked = true;
            //     }
            //     //this.onSiteRoleChange(user);
            // });
            this.totalItems = response.totalCount;
            this.UsersList.forEach((user: any) => {
                user.isChecked = user.siteRole !== null && user.siteRole !== undefined;
                user.isRoleFromAPI = user.siteRole !== null && user.siteRole !== undefined;
            });
        });

        console.log('the page number is', this.pageNumber);
    }

    onPageChangedUserGroup(event: any) {
        this.isLoadingDataUserGroup = true;
        console.log('this is called first - 1');
        this.pageNumber = event;
        this.isAllChecked = false;
        this.isAllCheckedUsergroup = false;
        const offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        const limit = this.pageNumber.page === this.totalPages ? this.totalItems - offset : this.itemsPerPage;
        //this.isLoadingData = true;
        this.currentLimit = limit;
        this.currentOffset = offset;
        const req = {
            userGroupFilter: {
                clientIds: this.selectedClientIds.length > 0 ? this.selectedClientIds : [],
                query: this.searchUserGroupName,
                limit: limit,
                offset: offset,
                sortBy: 'UserGroupName',
                order: 'DESC',
            },
            siteId: this.siteID,
        };
        this.myknowledgestore.getUserGroupsBySiteId(req).subscribe((data: any) => {
            this.isLoadingDataUserGroup = false;
            //this.isLoadingData = false;
            console.log('user groups by site ID', data);
            this.siteUserGroupsList = data.userGroups;
            console.log('siteUserGroupsList', this.siteUserGroupsList);
            this.siteUserGroupsList.forEach((userGroup: any) => {
                userGroup.savedSiteRole = userGroup.siteRole;
                if (userGroup.siteRole === null || userGroup.siteRole === undefined) {
                    userGroup.isChecked = false;
                } else {
                    userGroup.isChecked = true;
                }
            });
        });
    }

    searchClientName: string = '';

    userSearchList() {
        this.currentPage = 1;
        if (this.searchClientName != '') this.loadUsers();
    }

    userGroupAllList: any;

    loadAllUsergroup(): void {
        const usergroupData = { query: '', limit: 0, offset: 0, clientIds: [], order: 'DESC', sortBy: 'UserGroupName' };
        this.myknowledgestore.getUsergroup(usergroupData).subscribe({
            next: (data) => {
                this.userGroupAllList = data.userGroups || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }

    isChecked: boolean = true;

    onItemChange(user: any) {
        this.isAllChecked = this.UsersList.every((u: any) => u.isChecked);

        console.log('onItemChange');
        user.isModified = true;
        // Check if siteRole is null or undefined to toggle validation flag
        if (user.siteRole === null || user.siteRole === undefined) {
            user.showSiteRoleValidation = true;
        } else {
            user.showSiteRoleValidation = false;
        }

        // Highlight the dropdown if both conditions are true
        if (user.isChecked && user.showSiteRoleValidation) {
            user.highlight = true; // Set highlight flag to true
        } else {
            user.highlight = false;
        }

        console.log(user);
    }

    onItemChangeUserGroup(userGroup: any) {
        if (this.isOpenUserGroupModal) {
            this.isAllCheckedUsergroup = this.siteUserGroupsList.every((u: any) => u.isChecked);
        }

        console.log('onItemChange');
        userGroup.isModified = true;
        // Check if siteRole is null or undefined to toggle validation flag
        if (userGroup.siteRole === null || userGroup.siteRole === undefined) {
            userGroup.showSiteRoleValidation = true;
        } else {
            userGroup.showSiteRoleValidation = false;
        }

        // Highlight the dropdown if both conditions are true
        if (userGroup.isChecked && userGroup.showSiteRoleValidation) {
            userGroup.highlight = true; // Set highlight flag to true
        } else {
            userGroup.highlight = false;
        }

        console.log(userGroup);
    }

    // checkDisableForm(): boolean {
    //     if (!this.UsersList || this.UsersList.length === 0) {
    //         return true; // Disable if no users are available
    //     }

    //     // Enable the button only if at least one row has both `isChecked` and a valid `siteRole`
    //     return !this.UsersList.some((user: any) => user.isChecked && user.siteRole);
    // }

    checkDisableForm() {
        // let isDisable = false;
        // this.UsersList.forEach((item: any) => {
        //     if (item.isChecked && item.siteRole === null) {
        //         isDisable = true;
        //     }
        //     if (!item.isChecked && item.siteRole !== null) {
        //         isDisable = true;
        //     }
        // });
        // return isDisable;
        let countChecked = 0;
        let countOnlyChecked = 0;
        if (this.UsersList !== null) {
            this.UsersList.forEach((item: any) => {
                if (item.isChecked) {
                    countOnlyChecked++;
                }
                if (item.isChecked && item.siteRole === null) {
                    countChecked++;
                }
            });
        }
        if (countOnlyChecked > 0) {
            return countChecked > 0;
        } else {
            return true;
        }
        return countChecked > 0 && countOnlyChecked > 0;
    }

    checkDisableFormUserGroup(): boolean {
        if (!this.siteUserGroupsList || this.siteUserGroupsList.length === 0) {
            return true; // Disable if no users are available
        }

        // Enable the button only if at least one row has both `isChecked` and a valid `siteRole`
        return !this.siteUserGroupsList.some((userGroup: any) => userGroup.isChecked && userGroup.siteRole);
    }

    // onSiteRoleChange(user: any) {
    //     if (!user.siteRole) {
    //         // Agar null ya undefined hai toh
    //         user.statusCode = null;
    //         user.isChecked = false; // Checkbox bhi uncheck ho jaye
    //     } else {
    //         user.isChecked = true;
    //     }
    //     user.isModified = user.siteRole !== user.savedSiteRole;
    // }

    onSiteRoleChange(user: any) {
        if (user.siteRole == null) {
            // Agar null ya undefined hai toh
            user.statusCode = null;
            user.isChecked = false; // Checkbox bhi uncheck ho jaye
        } else {
            user.isChecked = true;
            user.highlight = false;
        }
        user.isModified = true;
    }

    onCheckBoxChange(user: any, event: any) {
        user.isChecked = event.target.checked;
        if (user.isChecked) {
            user.isModified = true; // Enable role and revoke button
        }
    }

    // Function to revoke a user
    onRevokeUser(user: any): void {
        // Set the revoking state to true while the operation is in progress
        user.revokeloading = true;

        // Send the delete request to revoke the user
        this.myknowledgestore.deleteUser(this.mksid, user.user.userId).subscribe({
            next: (response) => {
                // Reset the revoking state and update user data on successful revocation
                user.revokeloading = false;
                console.log('User revoked successfully:', response);

                // Update user properties to reflect the revocation
                user.revoked = true;
                user.siteRole = null; // Reset the user's role
                user.isChecked = false; // Reset any checked state if needed
                user.statusCode = null; // Optionally reset the user's status code

                console.log('Updated user object:', user);
                this.toast.success(response.message); // Show success toast

                // Optionally refresh user list if needed
                // this.getUsersBySite();
            },
            error: (err) => {
                // Handle errors and reset revoking state on failure
                user.revokeloading = false;
                console.error('Error revoking user:', err);
                this.toast.error(err?.error?.message); // Show error toast
            },
        });
    }

    isSaveUser = false;
    disableSaveButton: boolean = false;

    SaveUsers(): void {
        const updatedUsers = this.UsersList.filter((user: any) => user.isChecked && user.siteRole && user.isModified);
        if (updatedUsers.length === 0) {
            console.log('No updates to save.');
            this.toast.warning('No updates to save Users.');
            return;
        }

        updatedUsers.forEach((user: any) => (user.loading = true));
        this.disableSaveButton = true;
        this.Loading = true;
        const reqBody = updatedUsers.map((user: any) => ({
            emailId: user.user.emailId,
            siteRole: user.siteRole,
            siteId: this.mksid,
        }));

        this.myknowledgestore.UpdateUser(reqBody).subscribe({
            next: (response) => {
                this.disableSaveButton = false;
                this.Loading = false;
                console.log('Users updated successfully:', response);
                // this.isSaveUser = false;
                response.forEach((resItem: any, index: number) => {
                    const user = updatedUsers[index];
                    if (user) {
                        user.statusCode = resItem.code;
                        user.loading = false;
                        user.error = resItem.message;
                        user.isModified = false;

                        if (resItem.code === 200) {
                            user.revoked = false;
                            user.isChecked = false;
                            user.isRoleFromAPI = true;
                        } else {
                            user.revoked = true;
                            user.isChecked = true;
                        }
                    }
                });
            },
            error: (err) => {
                console.error('Failed to update users:', err);
                this.toast.error('Error updating users.');
            },
        });
    }

    getUserlistLen() {
        if (this.UsersList !== null) {
            return this.UsersList.length > 0;
        }
        return false;
    }
    onClearSelectedClient(flag: boolean) {
        if (flag && this.searchUserGroupName == '') {
            this.getUserGroupsBySite();
        }
    }
    onSiteRoleChangeUserGroup(group: any) {
        if (group.siteRole === null) {
            //group.isChecked = false;
            group.statusCode = null;
        } else {
            group.isChecked = true;
            group.statusCode = null;
            group.revoked = false;
            group.highlight = false;
        }
        group.isModified = group.siteRole !== group.savedSiteRole;
        group.siteRoleExist = group.siteRole === group.savedSiteRole;
    }

    revokeUserGroup(userGroup: any): void {
        //if (confirm('Are you sure you want to revoke this User Group?')) {
        userGroup.revokeloading = true;
        this.myknowledgestore.deleteUserGroups(this.siteID, userGroup.details.name).subscribe({
            next: (response) => {
                userGroup.revokeloading = false;
                console.log('User Group revoked successfully:', response);
                console.log('site user group list after delete', this.siteUserGroupsList);
                userGroup.revoked = true;
                userGroup.siteRole = null;
                userGroup.isChecked = false;
                userGroup.statusCode = null;

                console.log('userGroup', userGroup);
                this.toast.success(response.message);

                //this.getUserGroupsBySite();
            },
            error: (err) => {
                console.error('Error deleting User Group:', err);
                this.toast.error(err.error.message);
            },
        });
        // }
    }

    saveUserGroups(): void {
        this.isSaveUserGroup = true;
        this.disableSaveButton = true;
        this.Loading = true;
        const updatedUserGroups = this.siteUserGroupsList.filter((userGroup: any) => userGroup.isChecked && userGroup.siteRole && userGroup.isModified && !userGroup.siteRoleExist);

        if (updatedUserGroups.length === 0) {
            console.log('No updates to save.');
            this.toast.warning('No updates to save User Groups.');
            return;
        }
        updatedUserGroups.forEach((group: any) => (group.loading = true));

        const reqBody = updatedUserGroups.map((userGroup: any) => ({
            userGroupName: userGroup.details.name,
            siteRole: userGroup.siteRole,
            siteId: this.siteID,
        }));

        this.myknowledgestore.UpdateUserGroup(reqBody).subscribe({
            next: (response) => {
                this.Loading = false;
                this.disableSaveButton = false;
                console.log('User updated successfully:', response);
                this.isSaveUserGroup = false;
                response.forEach((resItem: any, index: number) => {
                    // Find the corresponding user group by index
                    const userGroup = updatedUserGroups[index];

                    if (userGroup) {
                        userGroup.statusCode = resItem.code;
                        userGroup.loading = false;
                        userGroup.error = resItem.message;

                        if (resItem.code === 200) {
                            userGroup.revoked = false; // Keep revoke button visible
                            //this.toast.success(resItem.message);
                            userGroup.isChecked = false;
                            userGroup.savedSiteRole = userGroup.siteRole;
                            userGroup.siteRoleExist = true;
                        } else {
                            userGroup.revoked = true; // Hide revoke button
                            userGroup.isChecked = true;
                            //userGroup.siteRole = null;
                            //this.toast.success(resItem.message);
                        }
                        userGroup.isModified = false; // Reset modified flag
                    }
                });
            },
            error: (err) => {
                console.error('Failed to update user:', err);
            },
        });
    }

    toggleAllCheckboxes(): void {
        this.UsersList.forEach((user: any) => {
            user.isChecked = this.isAllChecked; // Set all checkboxes to the same value
            if (user.siteRole === null || user.siteRole === undefined) {
                user.showSiteRoleValidation = true;
            } else {
                user.showSiteRoleValidation = false;
            }

            if (user.isChecked && user.showSiteRoleValidation) {
                user.highlight = true;
            } else {
                user.highlight = false;
            }
        });
    }

    checkAllUserGroup(): void {
        this.siteUserGroupsList.forEach((userGroup: any) => {
            userGroup.isChecked = this.isAllCheckedUsergroup;
            if (userGroup.siteRole === null || userGroup.siteRole === undefined) {
                userGroup.showSiteRoleValidation = true;
            } else {
                userGroup.showSiteRoleValidation = false;
            }

            if (userGroup.isChecked && userGroup.showSiteRoleValidation) {
                userGroup.highlight = true;
            } else {
                userGroup.highlight = false;
            }
        });
    }

    handleRevoke(user: any): void {
        if (user.isPartOfUserGroup) {
            this.toast.error("Could not revoke since user's user group has access to this site");
        } else {
            this.onRevokeUser(user); // Call the existing function to proceed as normal
        }
    }
}
